import { Gender, PhoneNumberType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { emptyStringToNull } from '../_shared/coerce.js';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
export const importBookingSchema = z.object({
    email: z
        .string()
        .min(1, "L'adresse email est requise.")
        .email('Veuillez saisir une adresse email valide.'),
    lastName: z.string().min(1, 'Le nom de famille est requis.'),
    dossierNumber: z.string().min(1, 'Le numéro de dossier est requis.'),
});
export const updateEmailsSchema = z.object({
    email: z.string().email(),
    secondaryEmail: emptyStringToNull(z.string().email()),
    password: z.string().min(1),
});
export const updatePasswordSchema = z.object({
    confirmNewPassword: z.string().min(8),
    currentPassword: z.string().min(1),
    newPassword: z.string().min(8),
});
export const phoneNumberItemSchema = z.object({
    id: z.string().optional(),
    number: z.string().min(1),
    type: z.nativeEnum(PhoneNumberType),
});
export const updatePhoneNumbersSchema = z.object({
    phoneNumbers: z.array(phoneNumberItemSchema),
});
// Champs B2C (firstName/lastName/birthDate/gender) et B2B (companyName/adresse)
// cohabitent en optionnel : l'espace client envoie l'un ou l'autre selon le type
// de client. Le SIRET et le contact référent (Client.firstName/lastName d'un B2B)
// restent en lecture seule et ne sont donc pas modifiables ici.
export const updateProfileSchema = z.object({
    companyName: emptyStringToNull(z.string()),
    firstName: personName({ optional: true }),
    lastName: personName({ optional: true }),
    address: emptyStringToNull(z.string()),
    birthDate: emptyStringToNull(isoDateString()),
    city: emptyStringToNull(z.string()),
    country: emptyStringToNull(z.string()),
    gender: emptyStringToNull(z.nativeEnum(Gender)),
    postalCode: emptyStringToNull(z.string()),
});
